export default "__VITE_ASSET__Crok9_CC__"